import { accountConstants } from './Account.constants';

var initialState = {
  hasWriteAccess: true,
  isDemoHost: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case accountConstants.GET_NICK_NAME_STORES_REQUEST:
      return {
        ...state,
        stores: { loading: true, error: false }
      };

    case accountConstants.GET_NICK_NAME_STORES_SUCCESS:
      return {
        ...state,
        stores: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case accountConstants.GET_NICK_NAME_STORES_FAILED:
      return {
        ...state,
        stores: { loading: false, error: true }
      };

    case accountConstants.GET_TOP_SOLD_STORES_REQUEST:
      return {
        ...state,
        TopStores: { loading: true, error: false }
      };

    case accountConstants.GET_TOP_SOLD_STORES_SUCCESS:
      return {
        ...state,
        TopStores: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case accountConstants.GET_TOP_SOLD_STORES_FAILED:
      return {
        ...state,
        TopStores: { loading: false, error: true }
      };

    case accountConstants.GET_TOP_SOLD_SKU_REQUEST:
      return {
        ...state,
        TopSKU: { loading: true, error: false }
      };

    case accountConstants.GET_TOP_SOLD_SKU_SUCCESS:
      return {
        ...state,
        TopSKU: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case accountConstants.GET_TOP_SOLD_SKU_FAILED:
      return {
        ...state,
        TopSKU: { loading: false, error: true }
      };

    case accountConstants.UPDATE_SELECTED_STORE:
      return {
        ...state,
        selectedStores: action.payload
      };

    case accountConstants.STORE_GROUP:
      return {
        ...state,
        storeGroup: action.payload
      };

    case accountConstants.UPDATE_SELECTED_TABLE_COLUMNS:
      return {
        ...state,
        selectedTableColumns: action.payload
      };

    case accountConstants.GET_LINKED_WAREHOUSE_REQUEST:
      return {
        ...state,
        warehouses: { loading: true, error: false }
      };

    case accountConstants.GET_LINKED_WAREHOUSE_FAILED:
      return {
        ...state,
        warehouses: { loading: false, error: true }
      };

    case accountConstants.GET_LINKED_WAREHOUSE_SUCCESS:
      return {
        ...state,
        warehouses: {
          loading: false,
          error: false,
          ...action.payload
        }
      };
    case accountConstants.GET_CALENDAR_EVENTS_REQUEST:
      return {
        ...state,
        calendarEvents: { loading: true, error: false }
      };

    case accountConstants.GET_CALENDAR_EVENTS_SUCESSS:
      return {
        ...state,
        calendarEvents: {
          ...action.payload,
          loading: false,
          error: false
        }
      };

    case accountConstants.GET_CALENDAR_EVENTS_FAILED:
      return {
        ...state,
        calendarEvents: { loading: false, error: true }
      };

    case accountConstants.UPDATE_ACCOUNT_ACCESS_TYPE:
      return {
        ...state,
        ...action.payload
      };
    case accountConstants.SET_IS_DEMO_HOST:
      return {
        ...state,
        isDemoHost: action.payload
      }

    default:
      return state;
  }
}
